module.exports = __webpack_public_path__ + "static/man-electrical-f1a5b4d38bf507344e7037297d39739c.png";